import { useState, useEffect } from 'react';

const getApiBase = () => {
  const hostname = window.location.hostname;
  const isLocal =
    hostname === "localhost" || hostname === "127.0.0.1" ||
    /^192\.168\./.test(hostname) || /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);
  if (isLocal) return `http://${hostname}:3001`;
  return process.env.REACT_APP_API_URL || '/api';
};

export const useAdminUploads = (category = null) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const base = getApiBase();
        const url = category 
          ? `${base}/adminUploads?category=${category}` 
          : `${base}/adminUploads`;
        const res = await fetch(url);
        if (res.ok) {
          const json = await res.json();
          setData(Array.isArray(json) ? json : []);
        }
      } catch (e) {
        console.warn('⚠️ Failed to fetch adminUploads:', e);
      }
    };
    fetchData();
  }, [category]);

  return data;
};